export function initDonatePage() {
  const tabButtons = document.querySelectorAll(".tab-btn");
  const tabContents = document.querySelectorAll(".tab-content");

  if (!tabButtons.length || !tabContents.length) return;

  tabButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const target = btn.dataset.tab;

      tabButtons.forEach((b) => b.classList.remove("active"));
      tabContents.forEach((c) => c.classList.remove("active"));

      btn.classList.add("active");
      document.getElementById(target).classList.add("active");
    });
  });
}

// Check if we are in an ACF block preview environment and hook into its render action.
if (window.acf) {
  window.acf.addAction("render_block_preview/type=donate-page", initDonatePage);
} else {
  document.addEventListener("DOMContentLoaded", function () {
    initDonatePage();
  });
}
